<template>
  <div>
    <!-- 政策模拟匹配 -->
    <div class="wrap-content">
      <div class="content-body" v-show="showFlag == 'accurateMatch'">
      <br/>
        <div style="padding:0 79px;">
          <span style="margin-left: 20px" class="result">
            <el-button class="computeBtn" round @click="groupTimeGX()"
            >按更新时间排序</el-button
            >
            <el-button class="computeBtn" round @click="groupTimeFB()"
            >按发布时间排序</el-button
            >
          </span>
          <div
            class="pad-1 bord-r-1 marg-tb-1 marg-rl-2 policy-item"
            v-for="(item, index) in listData"
            :key="index"
          >
            <!-- 回显支持匹配的政策 -->
            <div class="pad-rl-1 bord-r-1 policy-zcfs">
              <span
                v-for="(proj, index) in cpu_policyProjectList(item)"
                :key="index"
                v-show="proj.zcname"
                class="zcfs-item"
                >{{ proj.zcname }}</span
              >
            </div>
            <h3 class="policy-name" @click="toPolicyDetail(item)">
              {{ item.name }}
            </h3>
            <div class="policy-content">
              {{ item.content1.substr(0, 299) }}
            </div>
            <div class="policy-infos">
              <div
                v-for="(info, index) in policyInfos"
                :key="index"
                class="info-item"
                style="width: 20%; margin-top: 15px"
              >
                <label class="info-label">{{ info.label }}：</label>
                <div class="info-value">
                  <template v-if="info.valueFormatter">{{
                    info.valueFormatter(item)
                  }}</template>
                  <template v-else>{{ item[info.valueKey] }}</template>
                </div>
              </div>
              <div class="btn">
                <!-- <el-button
                  size="medium"
                  type="primary"
                  @click="showZcppDialog(item)"
                  >政策匹配</el-button
                > -->
                <span class="policyMatchTxt" @click="showZcppDialog(item)">
                  <i></i>政策匹配</span
                >
              </div>
            </div>
            <!--  <div class="policy_footer">
              <div class="policy-tag">
                <label>标签：</label>
                <div style="flex: 1">
                  <span
                    v-for="(tag, index) in item.policyClassificationValue"
                    :key="index"
                    class="marg-rl-2"
                    >{{ tag }}</span
                  >
                </div>
              </div>

            </div>-->
          </div>
        </div>
        <el-pagination
          class="marg-tb-2"
          style="text-align: center"
          background
          layout="prev,pager,next,total,jumper"
          :current-page.sync="pageInfo.page"
          :page-size.sync="pageInfo.size"
          :total="pageInfo.total"
          @current-change="changePage"
        ></el-pagination>
      </div>
      <policyMatch
        v-if="showFlag == 'policyMatch'"
        :policyName="policyName"
        :showForm="showForm"
        :percentage="percentage"
        :answerData="answerData"
        :isMatchData="isMatchData"
        @backEvent="backFunc"
        @backEventTwo="backFuncTwo"
      ></policyMatch>
    </div>
    <el-dialog
      title="政策匹配"
      :visible.sync="dialogVisible"
      width="45%"
      v-loading="loading"
      @close="closeDialog"
    >
      <!-- 匹配问题 -->
      <!-- v-if="!isShowRes" -->
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item
          v-for="(item, index) in showForm"
          :key="item.sqPolicyProblem.id"
          :label="index + 1 + '、' + item.sqPolicyProblem.name"
          :prop="item.sqPolicyProblem.id"
        >
          <FormRadioGroup
            @change="radioChange($event, index)"
            v-model="formData[index]"
            :options="item.sqPolicyProblemChildList"
            valueKey="id"
            labelKey="name"
          ></FormRadioGroup>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">开始匹配</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import policyMatch from "./policyMatch";
// import TjCommonDialog from "@/components/tj-common-dialog/TjCommonDialog";/
import $tjCommonDialog from "@/components/tj-common-dialog/index.js";
import { LOGIN_URL, LOGIN_URL_BACK } from "@/store/mutation-types";
import { FormRadioGroup } from "@/components/form/index.js";
export default {
  name: "AccurateMatch",
  components: {
    policyMatch,
    // TjCommonDialog,
    // $tjCommonDialog,
    FormRadioGroup,
  },
  props: {},
  data() {
    return {
      checkedAanswer: [],
      showForm: [],
      zcid: "", //政策id
      policyName: "", //政策名称
      showFlag: "accurateMatch",
      dialogVisible: false,
      loading: false,
      listData: [],
      policyInfos: [
        {
          label: "政策等级",
          valueFormatter: (item) => {
            if (!item.areaid) return "--";
            return this.getDictLabel("areaLevel", item.areaid);
          },
        },
        // {
        //   width: "400px",
        //   label: "发文单位",
        //   valueKey: "fbjg",
        // },
        {
          label: "发布日期",
          valueKey: "publictime",
        },
      ],
      pageInfo: {
        page: 1,
        size: 10,
        total: 0,
      },
      formData: {}, // 表单数据
      answerData: [], //企业回答数据
      isMatchData: [], //是否匹配数据
      rules: {}, // 表单校验
      isShowRes: false, //控制 问答 跟 匹配结果
      percentage: "", //匹配百分比
      sortByType: 1, //  0 是更新时间排序    1是发布时间排序
    };
  },
  created() {
    this.queryListData();
    //this.getMatchProblem();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      token: "getToken",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    /**
     * @description: 税类型下的标签列表
     * @return {Array}
     */
    cpu_tagList() {
      // 标签的parentId为父类的id
      let arr = this.searchInfo.typeTagData.filter((cv) => cv.parentId !== "0");
      if (!this.searchInfo.data.type) return arr;
      return arr.filter((cv) => cv.parentId == this.searchInfo.data.type);
    },
    cpu_policyProjectList() {
      return function (policy) {
        return policy.cfgPermitItemInfoList || [];
      };
    },
  },
  methods: {
    //按照发布时间
    groupTimeFB() {
      this.sortByType = 1;
      this.queryListData();
    },
    //按照更新时间
    groupTimeGX() {
      this.sortByType = 0;
      this.queryListData();
    },

    closeDialog() {
      this.dialogVisible = false;
    },
    backFunc(param) {
      this.showFlag = param;
    },
    backFuncTwo(param){
      this.$emit("backEvent",param)
    },
    radioChange(val, index) {
      this.$forceUpdate();
      if (this.checkedAanswer.indexOf(index) == -1) {
        this.checkedAanswer.push(index);
      }
    },
    changeTab(e) {
      // console.log('goQuickEntry:', e)
      if (e.target.nodeName.toLowerCase() === "li") {
        this.tabInfo.active = e.target.getAttribute("data-cpn");
      }
    },
    changePage() {},
    toAdvisory() {},
    showZcppDialog(policy) {
      // 该页面需要登录，若未登录，提示并重定向到 单点登录页面
      if (!this.token && !this.userInfo) {
        let cf = window.confirm("登录后即可访问'精准匹配'，即将前往登录");
        if (cf) {
          // let url = `${LOGIN_URL}?refer=cp&backUrl=${LOGIN_URL_BACK}`;
          // url += `?targetUrl=${window.location.host}`;
          // window.location.href = url;
          this.$router.push({ path: "/login2" });
          //window.location.href = "http://222.141.201.20:8060/#/login2"
        } else {
          this.$router.go(-1);
        }
        return;
      } else {
        this.zcid = policy.id;
        this.policyName = policy.name;
        this.formData = {};
        this.dialogVisible = true;
        this.getMatchProblem();
      }
    },
    queryListData() {
      let url = "/sqzd/policy/policyInfoList";
      // let params = {
      //   fbjg: "国家税务总局信阳市税务局",
      //   remark: this.searchInfo.data.tag.join(","),
      //   orderBy: this.searchInfo.data.releaseTime == 1 ? "desc" : "asc",
      //   name: this.searchInfo.data.keywords,
      // };
      let params = {
        isMatch: "1",
        orderBy:this.sortByType
      };
      this.$httpApi.post(url, params).then((res) => {
        if (res.rows && !!res.rows.length) {
          this.listData = res.rows;
          this.pageInfo.total = res.total;
        }
      });
    },
    getPolicyRes() {
      // 请求结束，切换成匹配结果
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    submitForm() {
      // 去重
      let tt = [];
      this.showForm.forEach((item, index) => {
        tt.push(index);
      });
      let num = "";
      let index = this.showForm.length;
      let indexS = [];
      let i = 0;
      for (i; i < index; i++) {
        indexS.push(i);
      }
      let numTwo = []
      indexS.forEach((item, index) => {
        if (this.checkedAanswer.indexOf(item) == -1) {
          numTwo.push(item)
        }
      });
      numTwo.forEach((item, index) => {
        let i = item + 1;
        num = num + i + ",";
      });
      num = num.substring(0, num.length - 1);
      if (num) {
        alert("请回答完整，第" + num + "个问题没有回答");
      } else {
        // 加载动画
        this.loading = true;
        let answerId = "";
        for (var key in this.formData) {
          if (this.formData[key]) {
            answerId += this.formData[key] + ",";
          }
        }
        // 拼装答案数据
        let temp = [];
        let isMatchTemp = [];
        this.showForm.forEach((item, index) => {
          (temp[index] = {}), (isMatchTemp[index] = {});
          item.sqPolicyProblemChildList.forEach((itemm) => {
            temp[index][itemm.id] = itemm.name;
            isMatchTemp[index][itemm.id] = itemm.iscorrect;
          });
        });
        let answerArr = [],
          isMatch = [];
        for (let key in this.formData) {
          let asw = temp[key][this.formData[key]];
          answerArr.push(asw);
          let ism = isMatchTemp[key][this.formData[key]];
          isMatch.push(ism);
        }
        this.answerData = answerArr; //企业回答数据
        this.isMatchData = isMatch; //是否匹配数据
        answerId = answerId.substring(0, answerId.length - 1);
        let url = `/dev-api/sqPolicyProblem/result/getPolicyIssueResults/${this.zcid}/${this.userInfo.tyshxydm}/${answerId}`;
        let that = this;
        that.$httpApi
          .get(url)
          .then((res) => {
            if (res.code == 200) {
              if (JSON.stringify(res.data) == "{}") {
                that.percentage = 0;
              } else {
                that.percentage = res.data.double.toFixed(2);
              }
              that.loading = false;
              that.dialogVisible = false;
              that.showFlag = "policyMatch";
              that.checkedAanswer = [];
            }
          })
          .catch((e) => {});
      }
    },
    /**
     * @description: 前往政策详情页面
     * @param {Object} policy 政策
     */
    toPolicyDetail(policy) {
      window.sessionStorage.setItem("policyDetailData", JSON.stringify(policy));
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      // this.$router.push({
      //   name: "showPolicyDetail",
      //   query: {
      //     showSideNav: true,
      //   },
      // });
      let { href } = this.$router.resolve({
					name: "showPolicyDetail",
          query: {
            showSideNav: true,
          },
				});
		  window.open(href, "_blank");
    },

    resetForm() {
      this.$refs["ruleForm"].resetFields();
      this.formData = {};
    },

    getMatchProblem() {
      let url = "/dev-api/sqPolicy/problem/treelist";
      let params = {
        serviceCode: this.zcid,
        // 这个政策id有数据
      };
      let that = this;
      this.$httpApi.get(url, params).then((res) => {
        if (res.code == 200 && !!res.rows.length) {
          that.showForm = res.rows;
          res.rows.forEach((item, index) => {
            that.formData[index] = item.sqPolicyProblem.id;
          });
          for (let i = 0; i < res.rows.length; i++) {
            // 表单添加响应属性
            // that.$set(this.formData, res.rows[i].sqPolicyProblem.id, '')
            // 表单添加校验
            that.rules[res.rows[i].sqPolicyProblem.id] = [
              {
                trigger: "change",
                required: true,
                message: "",
              },
            ];
            // 表单添加结构
            // let p = {
            //     id: res.rows[i].sqPolicyProblem.id,
            //     name: res.rows[i].sqPolicyProblem.name,
            //     children: res.rows[i].sqPolicyProblemChildList,
            //     correct: '',
            // }
            // p.correct = p.children.find(cv => cv.isCorrect === 'yes').name
            // that.showForm.push(p)
          }
          // console.log(that.showForm);
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.wrap-container {
  width: $width;
  margin: 0 auto;
}
.tabbar {
  position: relative;
  margin-top: 10px;
  font-size: 18px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #d71517;
  }
}
.tab-item {
  display: inline-block;
  padding: 0.5rem 1rem;
  color: #d71517;
  cursor: pointer;

  &.tab--active {
    color: #fff;
    background-color: #d71517;
    // border-bottom: 4px solid #d71517;
  }
}
.wrap-content {
  background-color: #ffffff;
  .content-body {
    min-height: 5rem;
    overflow: auto;
  }
}
.policy-item {
  border: 1px solid rgba($col-theme, 0.5);
  -webkit-transition: all 0.4s ease 0s;
  -moz-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;

  .policy-zcfs {
    .zcfs-item {
      display: inline-block;
      border: 1px solid $col-theme;
      color: $col-theme;
      margin-left: -10px;
    }
  }
  .policy-name {
    color: #000000;
    cursor: pointer;
    &:hover {
      color: $col-theme;
    }
  }
  .policy-content {
    color: #000000;
  }
  .policy-infos {
    display: -webkit-flex;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 5px;
    border-top: 1px solid rgba(224, 36, 10, 0.5);

    .info-item {
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;

      .info-value {
        flex: 1;
        min-width: 0;
      }
    }
    .btn {
      margin-left: 49%;
      width: 11%;
      ::v-deep .el-button--medium {
        margin-top: 1px;
        width: 160px;
        height: 40px;
      }
      .policyMatchTxt {
        color: #1472FF;
        display: flex;
        align-items: center;
        margin: 10px;
        cursor: pointer;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          background-position: center;
          background-image: url("~@/assets/images/policyMatch.png");
        }
      }
    }
  }
  .policy_footer {
    // padding-top: 5px;
    // padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba($col-theme, 0.5);
    margin-top: 5px;
    margin-bottom: -9px;
    overflow: auto;
    .btn {
      float: right;
      ::v-deep .el-button--medium {
        margin-top: 1px;
        width: 160px;
        height: 40px;
      }
      .policyMatchTxt {
        color: #1472FF;
        display: flex;
        align-items: center;
        margin: 10px;
        cursor: pointer;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          background-position: center;
          background-image: url("~@/assets/images/policyMatch.png");
        }
      }
    }
  }
  .policy-tag {
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
  }
  &:hover {
    box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}
::v-deep .el-form-item__error {
  display:none;
}
.policy-item .policy_footer {
  display: block;
}
.result {
  font-size: 18px;
  right: 36px;
}
</style>
